import React, { useContext, useEffect, useState } from "react";
import ScrollBar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import FilterCheckbox from "./FilterCheckbox";
import { filters, facets } from "../../assets/data/search";
import styles from "../../styles/SearchFilter.module.css";

import { SearchContext } from "../../store/search-context";
// import { SearchFitlerProps } from '../../types/interface'
import { meiliSearchAPI } from "../../services/api/meilisearch";
import Spinner from "../UI/Spinner";
import { getCookie } from "../../utils/common";
import MultiRangeSlider from "../Common/MultiRangeSlider";

const Filters = () => {
  useEffect(() => {
    getFacetsDistribution();
  }, []);

  const searchCtx = useContext(SearchContext);
  const searchFilters = searchCtx.filters;

  const [newKeyword, setNewKeyword] = useState<string>("");
  const [facetsDistribution, setFacetsDistribution] = useState<any>({});
  const [isFacetsDistributionLoading, setIsFacetsDistributionLoading] =
    useState(true);

  const updateKeywordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewKeyword(e.target.value);
  };

  const addKeywordHandler = () => {
    const currentFilters = { ...searchFilters };
    const value = newKeyword.trim();
    if (!currentFilters["keywords"] && value.length) {
      currentFilters["keywords"] = [value];
    } else if (currentFilters["keywords"]) {
      currentFilters["keywords"].push(value);
    }
    searchCtx.updateFilters(currentFilters);
    setNewKeyword("");
  };

  const removeKeywordHandler = (keyword: string) => {
    const currentFilters = { ...searchFilters };
    let keywordIndex = currentFilters["keywords"].indexOf(keyword);
    currentFilters["keywords"].splice(keywordIndex, 1);
    if (!currentFilters["keywords"].length) {
      delete currentFilters["keywords"];
    }
    searchCtx.updateFilters(currentFilters);
  };

  const availableKeywordsUI =
    searchCtx.filters["keywords"] &&
    searchCtx.filters["keywords"].length &&
    searchCtx.filters["keywords"].map((keyword: string, i: number) => {
      return (
        <li
          key={`keywordlist-${i}`}
          className="p-1 d-inline-flex align-items-center mb-1 me-2"
        >
          <span>{keyword}</span>
          <i
            className="bi bi-x ps-1"
            role="button"
            onClick={() => removeKeywordHandler(keyword)}
          ></i>
        </li>
      );
    });

  const debounce = (func: any, delay: any) => {
    let timeoutId: any;
    return function (...args: any) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const handleSliderChange = debounce(async (min: any, max: any) => {
    const currentFilters = { ...searchFilters };
    currentFilters["score_from"] = min;
    currentFilters["score_to"] = max;
    if (min === 0 && max === 100) {
      delete currentFilters["score_from"];
      delete currentFilters["score_to"];
    }
    searchCtx.updateFilters(currentFilters);
  }, 300);

  const getFacetsDistribution = () => {
    setIsFacetsDistributionLoading(true);

    // Get all facets AI signal from the facets data
    // let data = {
    //     facets: facets.map((facet: {[key: string]: string}) => facet.slug)
    // }
    const tenantSlug = getCookie("current_tenant");
    meiliSearchAPI?.(tenantSlug)
      .getAll?.(`?get_facets_distribution=true `)
      .then((response) => {
        setIsFacetsDistributionLoading(false);
        setFacetsDistribution(response);
      })
      .catch((err) => {
        setIsFacetsDistributionLoading(false);
        console.log(err);
      });
  };

  const facetsUI = filters.map(
    ({ id, title, slug, signal = "", parameters }) => {
      // app cx topics to the filters topics list
      if (slug === "cx_topics") {
        if (
          facetsDistribution &&
          Object.keys(facetsDistribution).length > 0 &&
          facetsDistribution[signal] &&
          Object.keys(facetsDistribution[signal]) &&
          Object.keys(facetsDistribution[signal]).length > 0
        ) {
          let paramsList = Object.keys(facetsDistribution[signal]).map(
            (data, i) => {
              let newParameter = {
                id: i + 1,
                title: data,
                slug: data,
              };
              return newParameter;
            }
          );
          parameters = [...parameters, ...paramsList];
        }

        return (
          <div
            className="accordion-item bg-transparent border-0 mb-3"
            key={`filter-${id}`}
          >
            <h2
              className={styles.accordionHeader}
              id={`panelsStayOpen-heading-${id}`}
            >
              <button
                className={`${styles.accordionButton} accordion-button bg-transparent ps-0 py-1`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#panelsStayOpen-collapse-${id}`}
                aria-expanded="true"
                aria-controls={`#panelsStayOpen-collapse-${id}`}
              >
                {title}
              </button>
            </h2>
            <ScrollBar>
              <div
                style={{ maxHeight: "200px" }}
                id={`panelsStayOpen-collapse-${id}`}
                className="accordion-collapse collapse show"
                aria-labelledby={`panelsStayOpen-collapse-${id}`}
              >
                <ul className="list-unstyled m-0">
                  <FilterCheckbox filterSlug={slug} parameters={parameters} />
                </ul>
              </div>
            </ScrollBar>
          </div>
        );
      } else {
        return (
          <div
            className="accordion-item bg-transparent border-0 mb-3"
            key={`filter-${id}`}
          >
            <h2
              className={styles.accordionHeader}
              id={`panelsStayOpen-heading-${id}`}
            >
              <button
                className={`${styles.accordionButton} accordion-button bg-transparent ps-0 py-1`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#panelsStayOpen-collapse-${id}`}
                aria-expanded="true"
                aria-controls={`#panelsStayOpen-collapse-${id}`}
              >
                {title}
              </button>
            </h2>
            <div
              id={`panelsStayOpen-collapse-${id}`}
              className="accordion-collapse collapse show"
              aria-labelledby={`panelsStayOpen-collapse-${id}`}
            >
              <ul className="list-unstyled m-0">
                <FilterCheckbox filterSlug={slug} parameters={parameters} />
              </ul>
            </div>
          </div>
        );
      }
    }
  );

  return (
    <div className={styles.filterAccordian}>
      {/* Checkboxes */}
      {isFacetsDistributionLoading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner size="md" />
        </div>
      ) : (
        <>
          {facetsUI}

          {/* QA Score */}
          <div className="accordion-item bg-transparent border-0">
            <h2
              className={styles.accordionHeader}
              id={`panelsStayOpen-heading-qa-score`}
            >
              <button
                className={`${styles.accordionButton} accordion-button bg-transparent ps-0`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapse-qa-score"
                aria-expanded="true"
                aria-controls="#panelsStayOpen-collapse-qa-score"
              >
                QA Score
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapse-qa-score"
              className="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-collapse-qa-score"
            >
              <div className="range-slider">
                <MultiRangeSlider
                  min={0}
                  max={100}
                  onChange={({ min, max }) => {
                    handleSliderChange(min, max);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Keywords */}
          <div className="accordion-item bg-transparent border-0">
            <h2
              className={styles.accordionHeader}
              id={`panelsStayOpen-heading-keywords`}
            >
              <button
                className={`${styles.accordionButton} accordion-button bg-transparent ps-0`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapse-keywords"
                aria-expanded="true"
                aria-controls="#panelsStayOpen-collapse-keywords"
              >
                Keywords
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapse-keywords"
              className="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-collapse-keywords"
            >
              <div className="form-group">
                <div className="input-wrap">
                  <div
                    className={`add-keyword-wrapper d-flex ${styles.addKeywordBlock}`}
                  >
                    <input
                      type="text"
                      name="newKeyword"
                      autoComplete="off"
                      placeholder="keywords"
                      value={newKeyword}
                      onChange={updateKeywordHandler}
                      className="p-2"
                    />
                    <button
                      className={`btn btn-primary btn-sm ${
                        !newKeyword.trim() && "disabled"
                      }`}
                      onClick={addKeywordHandler}
                    >
                      Add
                    </button>
                  </div>
                  <ul className={`${styles.keywordsList} mt-2 list-inline p-2`}>
                    {availableKeywordsUI}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Filters;
